export const KAKAO_TALK_ICON_IMAGE_URL = 'https://cf.fe.s.zigzag.kr/services/auth/assets/kakaotalk-icon.png';

export const PROTECT_SHIELD_URL = 'https://cf.fe.s.zigzag.kr/services/auth/assets/protect-shield.svg';
